export default "__VITE_ASSET__C_VDo2xn__"